module.exports = __webpack_public_path__ + "img/portrait-sara-katze.9e533473.webp";